import { HeaderCellProps } from '../types';

export const TenantCreatedAtHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Created At</div>;
};
